export default __webpack_public_path__ + "static/media/close_icon.c04519a7.svg";